import { render, staticRenderFns } from "./SystemFeatureNew.vue?vue&type=template&id=3c17ab4f&"
import script from "./SystemFeatureNew.vue?vue&type=script&lang=ts&"
export * from "./SystemFeatureNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports